import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { RiskFactors } from './RiskFactors';
import { Customer } from './Customer';
import { Assumptions } from '../static/Assumptions';
import { Utils } from '../Utils';
import { BigGameCountry as GQLBigGameCountry } from '@hit/hit-api-client';

@supertypeClass({ toClient: true, toServer: true })
export class BigGameCountry extends Persistable(Remoteable(Supertype)) implements GQLBigGameCountry {
  @property({ getType: () => RiskFactors })
  riskFactors: RiskFactors;

  @property({
    rule: ['required'],
    values: function () {
      const countries: string[] = Assumptions.allCountries;
      const policy = this.customer.application.primaryPolicy;
      const channelCode: string = policy.getChannelCode();
      if (Utils.isCoverpathPlatform(channelCode) && countries.indexOf('Other') === -1) {
        countries.push('Other');
      }
      return countries;
    },
  })
  name: string;

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer: Customer): BigGameCountry {
    return new BigGameCountry().init(customer);
  }

  init(customer: Customer): this {
    this.customer = customer;
    return this;
  }
}
